import getMutation from './get-mutation';

export default props => state => getMutation(state, props);
